export const WORKOUT_TYPE_LABELS = Object.freeze({
  home: 'HOME ARENA',
  gym: 'GYM STRONGHOLD',
  yoga_pilates: 'MINDFUL SANCTUARY',
  calisthenics: 'CALISTHENICS',
});

export const getWorkoutTypeLabel = (workoutType = '') => {
  const normalized = String(workoutType || '').trim().toLowerCase();

  if (WORKOUT_TYPE_LABELS[normalized]) {
    return WORKOUT_TYPE_LABELS[normalized];
  }

  if (!normalized) {
    return 'WORKOUT';
  }

  return normalized
    .replace(/[_/-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toUpperCase();
};
